import { render, staticRenderFns } from "./SCR_MBC_0117_02.vue?vue&type=template&id=1c73df07&scoped=true&"
import script from "./SCR_MBC_0117_02.vue?vue&type=script&lang=js&"
export * from "./SCR_MBC_0117_02.vue?vue&type=script&lang=js&"
import style0 from "./SCR_MBC_0117_02.vue?vue&type=style&index=0&id=1c73df07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73df07",
  null
  
)

export default component.exports